import { render } from "./NotesNotModerated.vue?vue&type=template&id=63f47df6"
import script from "./NotesNotModerated.vue?vue&type=script&lang=js"
export * from "./NotesNotModerated.vue?vue&type=script&lang=js"

import exportComponent from "/Users/pmerkuloff/Web/hlv/FRONT/hpanel/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__